var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1151 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745117 22.6384 0.745117 50.2484C0.745117 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74512 74.5084 6.74512 50.2484C6.74512 42.7784 8.61512 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0351 77.4184H44.4551C43.3251 77.4184 42.4151 76.4184 42.4151 75.1784H21.4851C21.4851 77.4484 23.1551 79.2784 25.2151 79.2784H76.2651C78.3251 79.2784 79.9951 77.4384 79.9951 75.1784H59.0651C59.0651 76.4184 58.1551 77.4184 57.0251 77.4184H57.0351Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6751 72.2984H74.8151C76.5751 72.2984 78.0051 70.8684 78.0051 69.1084V39.3484C78.0051 37.5884 76.5751 36.1584 74.8151 36.1584H26.6751C24.9151 36.1584 23.4851 37.5884 23.4851 39.3484V69.1084C23.4851 70.8684 24.9151 72.2984 26.6751 72.2984ZM26.5151 39.3584C26.5151 39.2684 26.5851 39.1984 26.6751 39.1984H74.8151C74.9051 39.1984 74.9751 39.2684 74.9751 39.3584V69.1184C74.9751 69.2084 74.9051 69.2784 74.8151 69.2784H26.6751C26.5851 69.2784 26.5151 69.2084 26.5151 69.1184V39.3584Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0851 48.8884C69.3551 48.8884 70.3851 47.8584 70.3851 46.5884C70.3851 45.3184 69.3551 44.2884 68.0851 44.2884C66.8151 44.2884 65.8451 45.2584 65.7951 46.4784C65.7951 46.5184 65.7951 46.5484 65.7951 46.5884C65.7951 47.2684 66.0851 47.8684 66.5551 48.2884C66.9651 48.6584 67.5051 48.8784 68.0951 48.8784L68.0851 48.8884Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7251 48.8884C40.0651 48.8884 40.3951 48.8084 40.6851 48.6784C41.3051 48.3984 41.7751 47.8384 41.9451 47.1684C41.9951 46.9884 42.0151 46.7884 42.0151 46.5884C42.0151 45.3184 40.9851 44.2884 39.7151 44.2884C38.4451 44.2884 37.4151 45.3184 37.4151 46.5884C37.4151 47.8584 38.4451 48.8884 39.7151 48.8884H39.7251Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1251 62.3684C36.3951 62.3684 37.4251 61.3384 37.4251 60.0684C37.4251 59.8584 37.3951 59.6484 37.3451 59.4584C37.1551 58.7684 36.6551 58.2184 36.0051 57.9484C35.7351 57.8384 35.4351 57.7784 35.1251 57.7784C33.8551 57.7784 32.8251 58.8084 32.8251 60.0784C32.8251 61.3484 33.8551 62.3784 35.1251 62.3784V62.3684Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8351 64.6584C53.1051 64.6584 54.1351 63.6284 54.1351 62.3584C54.1351 61.8584 53.9751 61.4084 53.7051 61.0284C53.3151 60.4784 52.6951 60.1084 51.9851 60.0684C51.9351 60.0684 51.8851 60.0684 51.8251 60.0684C50.5551 60.0684 49.5251 61.0984 49.5251 62.3684C49.5251 63.6384 50.5551 64.6684 51.8251 64.6684L51.8351 64.6584Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6451 59.3684L57.3351 54.5684C56.6851 54.3884 56.0951 54.0584 55.6251 53.6084L52.9351 58.4084C53.5851 58.5884 54.1651 58.9184 54.6451 59.3684Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7751 49.0284C64.3851 48.5084 64.1251 47.8884 64.0151 47.2184L61.7451 48.1684C62.1351 48.6884 62.3951 49.3084 62.5051 49.9784L64.7751 49.0284Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8951 54.7584C46.2751 55.0384 46.7351 55.1984 47.2451 55.1984C48.3251 55.1984 49.2351 54.4484 49.4751 53.4484C49.5151 53.2684 49.5451 53.0884 49.5451 52.8984C49.5451 52.3784 49.3751 51.8984 49.0851 51.5184C48.6651 50.9584 47.9951 50.5984 47.2451 50.5984C46.9051 50.5984 46.5751 50.6684 46.2851 50.8084C45.6651 51.0884 45.1951 51.6484 45.0251 52.3184C44.9751 52.5084 44.9551 52.6984 44.9551 52.8984C44.9551 52.9484 44.9551 52.9884 44.9551 53.0384C44.9951 53.7484 45.3551 54.3684 45.9051 54.7584H45.8951Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8151 49.5784L43.4151 48.3984C43.1251 48.9984 42.6851 49.5184 42.1551 49.9084L43.5551 51.0884C43.8451 50.4884 44.2851 49.9784 44.8151 49.5784Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3451 53.0584L54.7151 52.3684C54.4551 51.8284 54.3151 51.2384 54.3151 50.5984C54.3151 50.5484 54.3151 50.4884 54.3151 50.4384L50.9451 51.1284C51.2051 51.6684 51.3451 52.2584 51.3451 52.8984C51.3451 52.9484 51.3451 53.0084 51.3451 53.0584Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5251 51.9984L56.5951 51.9784C56.9851 52.4984 57.5851 52.8384 58.2751 52.8884C58.3251 52.8884 58.3851 52.8884 58.4351 52.8884C58.5351 52.8884 58.6351 52.8884 58.7351 52.8684C59.4351 52.7784 60.0351 52.3784 60.3851 51.7984C60.5851 51.4784 60.7051 51.0984 60.7251 50.6984C60.7251 50.6584 60.7251 50.6284 60.7251 50.5884C60.7251 49.9084 60.4351 49.3084 59.9651 48.8884C59.5551 48.5184 59.0151 48.2984 58.4251 48.2984C57.3451 48.2984 56.4351 49.0484 56.1951 50.0484C56.1551 50.2184 56.1251 50.4084 56.1251 50.5884C56.1251 51.0784 56.2851 51.5384 56.5551 51.9184L56.5151 51.9884L56.5251 51.9984Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9851 59.4484C62.7651 59.7984 62.6451 60.2184 62.6451 60.6584C62.6451 61.9284 63.6751 62.9584 64.9451 62.9584C66.2151 62.9584 67.2451 61.9284 67.2451 60.6584C67.2451 59.3884 66.2151 58.3584 64.9451 58.3584C64.8451 58.3584 64.7451 58.3584 64.6451 58.3784C63.9451 58.4684 63.3451 58.8684 62.9951 59.4484H62.9851Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9451 57.8384C62.3951 57.3584 62.9651 56.9884 63.5951 56.7684L61.4251 53.4184C60.9751 53.8984 60.4151 54.2684 59.7751 54.4884L61.9451 57.8384Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8051 56.9484C38.3051 57.3784 38.7051 57.9384 38.9551 58.5684L44.2151 55.6784C43.7751 55.1984 43.4451 54.6084 43.2651 53.9584L37.8051 56.9584V56.9484Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4551 23.4184L43.3151 28.1284C43.5451 28.2684 43.7851 28.3184 44.0351 28.2684C44.2951 28.2184 44.5051 28.0984 44.6851 27.9084C44.8651 27.7184 44.9551 27.4784 44.9551 27.1984C44.9551 26.7984 44.7751 26.4884 44.4251 26.2584L38.0151 22.4184L44.4251 18.6184C44.7751 18.4084 44.9551 18.0884 44.9551 17.6584C44.9551 17.2284 44.7751 16.9484 44.4251 16.7484C44.0651 16.5584 43.7051 16.5584 43.3151 16.7584L35.4551 21.4884C35.0751 21.7584 34.8751 22.0784 34.8751 22.4484C34.8751 22.8584 35.0651 23.1884 35.4551 23.4284V23.4184Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6051 31.4284C47.8051 31.4284 47.9951 31.3784 48.1951 31.2784C48.3851 31.1784 48.5251 31.0184 48.6151 30.7884L55.0251 14.7484C55.1851 14.3384 55.1451 13.9784 54.9251 13.6684C54.7051 13.3584 54.4151 13.2084 54.0451 13.2084C53.8351 13.2084 53.6351 13.2684 53.4451 13.3784C53.2651 13.4884 53.1251 13.6484 53.0451 13.8484L46.6351 29.8884C46.4751 30.2684 46.5051 30.6284 46.7051 30.9384C46.9151 31.2584 47.2151 31.4184 47.6151 31.4184L47.6051 31.4284Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5251 27.1884C56.5251 27.4684 56.6151 27.7084 56.7951 27.8984C56.9751 28.0884 57.1851 28.2084 57.4451 28.2584C57.7051 28.3084 57.9451 28.2584 58.1651 28.1184L66.0251 23.4084C66.4051 23.1684 66.6051 22.8384 66.6051 22.4284C66.6051 22.0584 66.4151 21.7384 66.0251 21.4684L58.1651 16.7384C57.7851 16.5384 57.4151 16.5384 57.0551 16.7284C56.6951 16.9184 56.5251 17.2184 56.5251 17.6384C56.5251 18.0584 56.7051 18.3884 57.0551 18.5984L63.4651 22.3984L57.0551 26.2384C56.6951 26.4684 56.5251 26.7784 56.5251 27.1784V27.1884Z",
    fill: "#9933CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1699",
    x: -0.0000186563,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1699",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1699"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1699",
    result: "effect3_innerShadow_4857_1699"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItDevelopment);
export default __webpack_public_path__ + "static/media/ItDevelopment.7e8ba44b3b0562d170be18a15c881dc4.svg";
export { ForwardRef as ReactComponent };